<template>
  <header class="pt-4 px-3 px-lg-4">
    <transition mode="out-in" name="slide-fade" appear>
      <p class="logo mb-0 text-center text-lg-start">
        <strong>SavaJava<sup>&trade;</sup></strong>
      </p>
    </transition>
    <transition mode="out-in" name="alert" appear>
      <h1 class="tagline text-center text-lg-start">
        <em
          >Reliable Stock's Dividend Safety Score and Cashflow Report at your
          fingertips
        </em>
      </h1>
    </transition>
  </header>
</template>
